import { Modal, Table } from '@mantine/core';
import { useEffect, useState } from 'react';
import ReactFlow, { Controls, Background, MarkerType} from 'reactflow';
import 'reactflow/dist/style.css';
import { nodeType } from '../../../../../types/types';
import CustomLoopNode from './CustomLoopNode/CustomLoopNode';
import CustomNode from './CustomNode/CustomNode';
import CustomNodeCost from './CustomNodeCost/CustomNodeCost';
import './CustomNode/CustomNode.css'


const nodeTypes = {
  custom: CustomNode,
  customCost: CustomNodeCost,
  customLoop: CustomLoopNode,
  fullTableScan: CustomLoopNode
};


export function QueryAnalyser(props:any) {
  const response= props.response;
  
  const[node, setNode] = useState<nodeType[]>([]);
  const [edges, setEdges] = useState<any[]>([])
  const [openTable, setOpenTable] = useState(false);
  const [selectedNode, setSelectedNode] = useState<any>(null);

  const handleNodeClick = (event: any, node: any) => {
    if(node.type === "custom" && node.data !== 'null'){
    setOpenTable(true);
    setSelectedNode(node);
    }
  }

  const handleClose = () => {
    setOpenTable(false);
    setSelectedNode(null);
  };

  
useEffect(() => {

let newNodes;
let loopNodes;
let newEdges;
let newLoopEdges;
  if(response?.features[0]?.explain?.loops === null){
    newNodes =  [{
      id : 'null',
      position: {x: 600, y: 400},
      data : 'null',
      selected : true,
      type: 'custom'
    }]
    loopNodes = [{
      id: 'Loop-0',
      position: { x: 736, y: 700 },
      data: 'null',
      selected: true,
      type: 'customLoop'
    }]
    newEdges = [{
      id: 'newEdge-0',
      source: 'null',
    targetHandle: "Top",
    target: 'Loop-0',
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 40,
      height: 40,
      color: '#000000',
    }
    }]
    setEdges([...newEdges]);
  }else{

newNodes = response?.features[0]?.explain?.loops?.map((i:any, index:any) => ({
    id: i.table[0] !== null? i.table[0].tableName: 'null',
    position: { x: (index+1) * 600, y: 600 },
    data: i.table[0] != null ? i.table[0] : 'null',
    selected: true,
    type: 'custom'
  }));
  loopNodes = response?.features[0]?.explain?.loops?.map((i:any,index:any) => ({
    id: `Loop-${index}`,
    position: { x: ((index+1) * 600)+136, y: 900 },
    data: i.table[0] != null ? i.table[0] : 'null',
    selected: true,
    type: 'customLoop'
  }));
  newEdges = response?.features[0]?.explain?.loops?.map((i:any,index:any) => ({
    id: `newEdge-${index + 1}`,
    source: i.table[0] !== null? i.table[0].tableName: 'null',
    targetHandle: "Top",
    target: `Loop-${index}`,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 40,
      height: 40,
      color: '#000000',
    }
  }));
  newLoopEdges = response?.features[0]?.explain?.loops?.map((i:any,index:any) => ({
    id: `newLoopEdge-${index + 1}`,
    source: `Loop-${index}`,
    sourceHandle: "Right",
    targetHandle: "Left",
    target: `Loop-${index + 1}`,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 40,
      height: 40,
      color: '#000000',
    }
  }));
  setEdges([...newEdges,...newLoopEdges]);
}
  setNode([...newNodes,...loopNodes]);
  
}, []);



  return (
   <Modal className = "modalContainer" size="80%"
   opened={props.showModal}
   onClose={() => props.setShowModal(false)}>
    <div className = "reactFlowQueryAnalyser" style={{width: '97%', height: '80vh'}} >
      <ReactFlow 
      nodes={node}
      onNodeClick={handleNodeClick}
      nodeTypes={nodeTypes}
      edges={edges}
      panOnScroll={true}
      defaultViewport={{x:-100, y: 10, zoom: 0}}
      >
        <Background />
        <Controls />
<div className = "tableReactFlow">
        <Table striped>
            <tbody>
        {Object.keys(response.features[0].explain.queryFlag).map((key) => (
          <tr key={key}>
            {key === 'Warning' ? <td style={{width: '20%', backgroundColor: '#FFFAA0'}}>{key}</td> : <td style={{width: '20%',  backgroundColor: '#F08080'}}>{key}</td>}
            {/* <td>{(response.features[0].explain.queryFlag[key].join('\r\n'))}</td> */}
            <td><pre>{(response.features[0].explain.queryFlag[key].join('\n'))}</pre></td>
          </tr>
        ))}
        {response.features[0].explain.costInfo !== null && Object.keys(response.features[0].explain.costInfo).map((key) => (
          <tr key={key}>
            <td style={{width: '20%'}}>{key}</td> 
            <td>{(response.features[0].explain.costInfo[key])}</td>
          </tr>
        ))}
      </tbody>
          </Table> 
          </div>
        
      </ReactFlow>
    </div>
    
    <Modal size = "60%" opened={openTable}
    onClose={handleClose}>
      <Table striped>
            <tbody>
              {selectedNode &&
                Object.keys(selectedNode['data']).map((key, index) => (
                  
                  <tr key={key}>
                    <td style={{width: '15%'}}>{key}</td>
                    <td>
                    {typeof selectedNode['data'][key] !== 'object' || Array.isArray(selectedNode['data'][key]) ? (selectedNode['data'][key]).toString() : JSON.stringify(selectedNode['data'][key])}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
  </Modal>
    </Modal>
  )
}
